import React from 'react';
import MessageItem, { Message } from './Message';
import { styles } from './Messages.css';

export type MessagesProps = {
  messages: Array<Message>;
  className?: string;
};

const Messages = ({ messages, className }: MessagesProps): JSX.Element => {
  if (!messages.length) return null;

  return (
    <div className={[styles.root, className].join(' ')}>
      {messages.map((message: Message) => (
        <MessageItem
          message={message}
          key={`${message.MessageType}${encodeURIComponent(message.Message.substring(0, 5))}`}
        />
      ))}
    </div>
  );
};

export default Messages;
